import wx from "weixin-js-sdk";
import api from '@/api'
const util = {}

/**
 * @description 更新标题
 * @param {String} title 标题
 */
util.title = function (titleText) {
  window.document.title = titleText
}
//初始化微信公众号配置
util.initWXSdk = function initWXSdk(shareParam) {
  const params = {
    // 当前页面路径
    url: window.location.href,
  };
  wx.checkJsApi({
    jsApiList: ['updateTimelineShareData', 'updateAppMessageShareData'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
    success: function (res) {
      if(res) {
        // console.log(res)
      }
      // 以键值对的形式返回，可用的api值true，不可用为false
      // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
    },

  });
  api.SYS_SHARE_INFO(params).then(function (res) {
    // console.log(res);
    if (!res) {
      res = {}
    }
    // 注入微信配置信息
    wx.config({
      debug: false, // true开启调试模式,pc端会console.log手机端会alert
      appId: res.appid, // 必填，公众号的唯一标识，填自己的！
      timestamp: res.timestamp, // 必填，生成签名的时间戳，刚才接口拿到的数据
      nonceStr: res.nonce_str, // 必填，生成签名的随机串
      signature: res.signature, // 必填，签名，见附录1
      jsApiList: ["updateTimelineShareData", "updateAppMessageShareData"],
    });
    // 处理微信配置成功验证
    wx.ready(function () {
      // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，
      // 所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。
      // 对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
      wx.updateAppMessageShareData({
        title: shareParam.title, // 分享时的标题
        desc: shareParam.desc,
        link: shareParam.link, // 分享时的链接
        imgUrl: shareParam.imgUrl, // 分享时的图标
        success: function () {

          // Toast('设置分享朋友圈成功')
        }
      })
      //朋友圈
      wx.updateTimelineShareData({
        title: shareParam.title,
        desc: shareParam.desc,
        link: shareParam.link,
        imgUrl: shareParam.imgUrl,
        success: function () {

          // Toast('设置分享朋友成功')
        }

      })

    });

    // 处理微信接口处理失败验证
    wx.error(function (res) {
      console.error("wx.config注册失败", res);
      // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
    });
  });
}

/**
 * @description 删除URL内微信信息
 * @param {String} url 标题
 */
util.deleteWechatInfo = function (url) {
  let codeIndex = url.indexOf('code=')
  if (codeIndex === -1) {
    // code不存在直接返回
    return url
  }
  let stateStr = `state=WnHRWxSTATE`
  let eIndex = url.indexOf(stateStr)
  if(eIndex !== -1) {
    // state存在, 删除code到state的字符串
    return url.substr(0, codeIndex) + url.substr(eIndex + stateStr.length)
  } else {
    // state不存在, 删除'code'
    return url.substr(0, codeIndex) + url.substr(codeIndex + 5)
  }
}

export default util
